import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import styles from '../VolunteeringFiltersModal.module.scss'
import { FilterProps } from '../VolunteeringFiltersModal.types'

import { Box, Loader, Select, SelectOption, Typography } from '@percent/lemonade'
import { getCampaigns } from '@percent/workplace-giving/api/campaigns/getCampaigns/getCampaigns'
import { useQuery } from '@percent/workplace-giving/common/hooks'

export function CampaignFilter({ selectedFilters, setSelectedFilters }: FilterProps) {
  const { t } = useTranslation()

  const { data: campaigns, isLoading } = useQuery(['getCampaigns'], getCampaigns, { staleTime: 1000 * 60 })

  const options: SelectOption[] = useMemo(
    () => (campaigns ?? []).map(({ id, title }) => ({ value: id, label: title })),
    [campaigns]
  )

  if (isLoading) {
    return <Loader />
  }

  return (
    <Box>
      <Typography className={styles.FiltersSectionTitle}>
        {t('workplace_giving.volunteering.filters.campaign')}
      </Typography>
      <Select
        placeholder={t('workplace_giving.volunteering.filters.campaignPlaceholder') as string}
        searchable
        options={options}
        defaultValue={options.find(option => option.value === selectedFilters.campaignId)}
        onChange={option => setSelectedFilters({ ...selectedFilters, campaignId: option.value })}
        data-testid="campaignFilterSelect"
        borderRadiiSize="large"
      />
    </Box>
  )
}
